import { Component, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { IncomeService, IncomeData, IncomedBill, IncomeBill, Income, IncomeFilter } from '../../services/income.service';
import { CustomerSupplierService } from '../../services/customer-supplier.service';
import { FiscalDataService } from '../../services/fiscal-data.service';

import { Observable } from 'rxjs/Observable';
import { Ng2TableModule } from 'ng2-table/ng2-table';
import { CatalogsSettingsService } from '../../services/catalogs-settings.service';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';
import { PermissionService } from '../../services/permission.service';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { Utils } from '../../util';

@Component({
  selector: 'app-read-income',
  templateUrl: './read-income.component.html',
  styleUrls: ['./read-income.component.css']
})
export class ReadIncomeComponent implements OnInit, OnDestroy {
  allowed: boolean = false;
  permission: any = {};

  incomes:any[] = [];

	data:Array<any>;
  rows:Array<any> = [];
  columns:Array<any> = [
    {title: 'Folio', name: 'name'},
    {title: 'Folio anterior', name: 'lastFolios'},
    {title: 'Fecha', name: 'date'},
    {title: 'Cliente', name: 'customerName'},
    {title: 'Número de cuenta', name: 'bankNumber'},
    {title: 'Forma de pago', name: 'payMethod'},
    {title: 'Monto', name: 'amount', className: 'tdRight thCenter'},
    { title: 'Acciones', className: 'center minTwoButtons',  name: 'actionGroup', sort: false, actions: { type: 'group', buttons: [
			{ name: 'edit', title: '', styleIcon: 'edit', action: 'onEdit',
				styleClass: 'btn-floating btn waves-effect light-green darken-1' },
			{ name: 'delete', title: '', styleIcon: 'delete', action: 'onDelete',
				styleClass: 'btn-floating btn waves-effect red darken-2', }
		] } }
  ];
  page:number = 1;
  itemsPerPage:number = 5;
  maxSize:number = 5;
  numPages:number = 1;
  length:number = 0;

  config:any = {
    paging: true,
    sorting: {columns: this.columns},
    filtering: {filterString: ''},
		api: {
			onEdit: this.onEdit.bind(this),
			onDelete: this.onDelete.bind(this)
		}
  };

  receivedAll: boolean = false;

  constructor(
    private service: IncomeService,
    private incomeData: IncomeData,
    private customerService: CustomerSupplierService,
		private fiscalDataService: FiscalDataService,
    private settings: CatalogsSettingsService,
		private permissionService: PermissionService,
    private authService: AuthService,
    private router: Router
  ) {
    let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
        permissionsSubs.unsubscribe();
        this.permission = this.permissionService.constructPermissionObject(groups, service.collection);
        if(!this.permission || !this.permission.readAction) this.router.navigate(['/']);
        else this.allowed = true;
    });

    this.subs[4] = this.settings.getPayrollSettings('1').subscribe(setting => {
      this.itemsPerPage = setting.tableQuantity;
    });
		this.subs[3] = this.service.getIncomesFifteenDays().subscribe(tempIncomes => {
			this.incomes = tempIncomes.map(income => {
        income.name = income.folio;
        income.lastFolios = income.folioLogs ? income.folioLogs.map(fl => fl.lastFolio).join(', ') : '';
        income.customerName = income.customerObj.name;
        income.bankNumber = income.bankObj.accountNumber;
        income.amount = this.money(income.amount);
        income.payMethod = this.incomeData.statusObjects[income.payMethod].name;
        return income;
      });
      this.filterBar = new IncomeFilter(this.incomes, {} );//JSON.parse(this.filterBar.json)
      this.applyFilterBar();
    });
    this.readObjs = [];
    this.readObjs[0] = {};
    this.subs[0] = this.customerService.getCustomers().subscribe(customers => {
      this.rowsRead[0] = customers.map(customer => {
        customer.id = customer.id$;
        this.readObjs[0][customer.id] = {...customer};
        return customer;
      });
    });

    this.readObjs[1] = {};
    this.subs[1] = this.fiscalDataService.getAllFiscalDatas().subscribe(fiscalDatas => {
      this.allFiscalRows = fiscalDatas.filter(fiscalData => {
        fiscalData.name = fiscalData.businessName;
        this.readObjs[1][fiscalData.id] = {...fiscalData};
        if(fiscalData.customerId) return fiscalData;
      });
		});

	}

  ngOnInit() {
  }
  ngOnDestroy(){
    this.subs.map((sub,index) => {
      this.subs[index].unsubscribe();
    });
  }

  deleteIncome(sid: string) {
    this.service.deleteIncome(sid);
	}

	onCellClick(data: any): any {
		this.service.windowReplace('view', data.row.id);
  }

  onCreate(){
    if(!this.permission.createAction) return toast('No tiene los permisos para crear.', 2000);
    this.continueReadTo(0);
  }

	onEdit(data: any) {
    if(!this.permission.updateAction) return toast('No tiene los permisos para editar.', 2000);
		this.service.windowReplace('edit', `${data.row.id}/${data.row.fiscalDataObj.id}/${data.row.customerObj.id}`);
	}

	onDelete(data: any) {
    if(!this.permission.deleteAction) return toast('No tiene los permisos para eliminar.', 2000);
    return !data.row.bills.length ? this.deleteIncome(data.row.id) : toast('Para eliminar un ingreso su monto debe de ser cero', 3000);
  }

  ////////////////////////////////////////////////////////////////////FilterBar
  filterBar: IncomeFilter = new IncomeFilter([],{});
  applyFilterBar(){
    //localStorage.incomeRead = this.filterBar.json;

    this.data = this.filterBar.filteredData;
    this.length = this.data.length;
    this.onChangeTable(this.config);
  }
  onChangeDateFilterBar(){
    if(this.filterBar.dateIndex && !this.receivedAll){
      this.subs[3].unsubscribe();
      this.subs[3] = this.service.getIncomes().subscribe(tempIncomes => {
        this.incomes = tempIncomes.map(income => {
          income.name = income.folio;
          income.lastFolios = income.folioLogs ? income.folioLogs.map(fl => fl.lastFolio).join(', ') : '';
          income.customerName = income.customerObj.name;
          income.bankNumber = income.bankObj.accountNumber;
          income.amount = this.money(income.amount);
          income.payMethod = this.incomeData.statusObjects[income.payMethod].name;
          return income;
        });
        this.filterBar = new IncomeFilter(this.incomes, JSON.parse(this.filterBar.json) );
        this.applyFilterBar();
      });
      this.receivedAll = true;
    }else{
      this.applyFilterBar();
    }
  }
  ////////////////////////////////////////////////////////////////////FilterBar
 
  money = Utils.money;

	//*********** Filter, sort, and pagination */

	changePage(page:any, data:Array<any> = this.data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  changeFilter(data:any, config:any):any {
    let filteredData:Array<any> = data;
    this.columns.forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columns.forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA 
  modalActionsRead = new EventEmitter<string|MaterializeAction>();
  modalParamsRead = [{dismissible: true}];
  openModalRead() {
    this.modalActionsRead.emit({ action: 'modal', params: ['open'] });
  }
  closeModalRead() {
    this.modalActionsRead.emit({ action: 'modal', params: ['close'] });
  }
  selectRead(data: any): any{
    this.selectedIds[this.currentReadIndex] = data.row.id;
    if(this.readValid) this.continueReadTo(this.currentReadIndex + 1);
  }
  continueReadTo(nextIndex){
    if(nextIndex == this.columnsRead.length){
      this.closeModalRead();
      this.service.windowReplace('add', `${this.selectedIds[1]}/${this.selectedIds[0]}`);
    }else{
      if(nextIndex == 1) this.rowsRead[nextIndex] = this.allFiscalRows.filter(fiscalRow => fiscalRow.customerId && fiscalRow.customerId == this.selectedIds[0]);
      this.currentReadIndex = nextIndex;
      this.r_data = this.rowsRead[nextIndex];
      this.r_config = this.r_configs[nextIndex];
      this.r_page = 1;
      this.r_onChangeTable(this.r_config);
      if(nextIndex == 0) this.openModalRead();
    }
  }
  goBackReadTo(prevIndex){
    if(prevIndex < 0){
      this.closeModalRead();
    }else{
      this.selectedIds[prevIndex + 1] = '';
      this.currentReadIndex = prevIndex;
      this.r_data = this.rowsRead[prevIndex];
      this.r_config = this.r_configs[prevIndex];
      this.r_onChangeTable(this.r_config);
    }
  }

  selectedIds: string [] = [];
  readObjs: any[] = [];
  subs: any[] = [];
  readPlaceholders = [ 'un cliente', 'su razón social' ]
  get readValid(){ return !!this.selectedIds[this.currentReadIndex] };
  currentReadIndex: number;
  allFiscalRows: any;
  rowsRead = [[], []];
  columnsRead = [
    [//customer
      { title: 'Nombre', name: 'name', sort: 'asc' },
      { title: 'Descripción', name: 'description' },
      { title: 'Correo electrónico', name: 'email' }
    ],
    [
      { title: 'Razón Social', name: 'name', sort: 'asc' },
      { title: 'RFC', name: 'rfc' }
    ]
  ]


  r_data:Array<any>;
  r_rows:Array<any> = [];
  r_page:number = 1;
  r_itemsPerPage:number = 5;
  r_maxSize:number = 5;
  r_numPages:number = 1;
  r_length:number = 0;

  
  r_configs:any = this.columnsRead.map(columns => ({
    paging: true,
    sorting: {columns: columns},
    filtering: {filterString: ''}
  }));
  r_config = this.r_configs[0];

  /*********** Filter, sort, and pagination */

	r_changePage(page:any, data:Array<any> = this.r_data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  r_changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.r_config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }
    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  r_changeFilter(data:any, config:any):any {
    console.clear();
    console.log(this.columnsRead[this.currentReadIndex])
    let filteredData:Array<any> = data;
    this.columnsRead[this.currentReadIndex].forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });
    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columnsRead[this.currentReadIndex].forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.r_config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  r_onChangeTable(config:any, page:any = {page: this.r_page, itemsPerPage: this.r_itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.r_config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.r_config.sorting, config.sorting);
    }

    let filteredData = this.r_changeFilter(this.r_data, this.r_config);
    let sortedData = this.r_changeSort(filteredData, this.r_config);
    this.r_rows = page && config.paging ? this.r_changePage(page, sortedData) : sortedData;
    this.r_length = sortedData.length;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA

}
